/** Sidebar navigation strings (extracted to keep en.ts under the size ratchet). */
export const enSidebar = {
	reviewDot: {
		knowledgeDb: "AI-generated content is ready — review and confirm it in the Knowledge Base.",
		copywriting: "Review your copywriting frameworks to confirm your setup.",
		templates: "Review your message templates to confirm your setup.",
	},
	clickToConnectLinkedIn: "Click to connect your LinkedIn account",
	clickToConnectSalesNav: "Click to connect your LinkedIn Sales Navigator account",
	listsAreBeingProcessed: "/ 2 lists are being processed",
	connectSignalistLinkedIn: "Please reconnect Signalist with your LinkedIn",
	connectSignalistSalesNav: "Please reconnect Signalist with your LinkedIn Sales Navigator",
	personalSettings: "Personal settings",
	personalSettingsTooltip:
		"Connect to Linkedin and email, change your password and manage your personal Linkedin network",
	myProfile: "Personal settings",
	creditsLeft: "<bold>{{count}}</bold> Credits left",
	clickToReconnect: "Click to reconnect",
	emailAccountsLoggedOut_one: "{{count}} email account logged out",
	emailAccountsLoggedOut_other: "{{count}} email accounts logged out",
	chooseEmailToReconnect: "Choose the account to reconnect",
	loggedInAs: "{{firstName}} {{lastName}} logged in as {{asFirstName}} {{asLastName}} of ",
	parallelAi: "AI Prompt",
	skipTrial: "Skip Trial to get credits",
	reactivateAccount: "Reactivate your account",
	noCredits: "No credits left",
	loading: "Loading",
	templates: "Templates",
	compose: "Compose",
	analytics: "Analytics",
	searches: "Search Prospects",
	prospects: "Prospects",
	stepstone: "Stepstone",
	northdata: "Federal Gazette",
	indeed: "Indeed",
	users: "Users",
	roles: "User roles",
	logout: "Logout",
	inbox: "Inbox",
	cookie: "Cookie",
	csvEnrichment: "Excel Enrichment",
	linkedinEvents: "LinkedIn Events",
	linkedinCompanyActivity: "Company Follower",
	linkedinProfileVisits: "LinkedIn Personal Profile Visits",
	linkedinProfile: "Person Custom Signal Tracker",
	linkedinPeopleSearch: "LinkedIn People Search",
	openai: "AI Enrichments",
	accounts: "Accounts",
	workflow: "Workflow",
	settings: "Settings",
	accountSettings: "Company Settings",
	helpConversations: "Help Conversations",
	copywriting: "Copywriting",
	profile: "My Profile",
	list: "Lists",
	dashboard: "Dashboard",
	listBuilder: "Lead Lists",
	customEvent: "Websites",
	leadScoring: "Lead Scoring",
	dataSources: "Data Sources",
	organization: "Your organization",
	blacklist: "Blacklist",
	companies: "Other organizations",
	back: "Back to your account",
	jobs: "Jobs offers",
	maps: "Google Maps",
	linkedinPosts: "LinkedIn Posts",
	all: "All",
	otherOrganizations: "Other Organizations",
	globalBlacklist: "Global Blacklist",
	signals: "Signal Scoring",
	knowledgeDb: "Knowledge Database",
	contacts: "Contacts",
	contactsCompanies: "Companies",
	competitors: "Competitors",
	integrations: "Integrations",
	tabs: {
		prospects: "Prospects",
	},
	globalSearch: "Search for anything",
	notifications: "Notifications",
	collapseSidebar: "Collapse sidebar",
	expandSidebar: "Expand sidebar",
	profileTracker: "Custom Signal Tracker",
	feed: "Feed",
	listViews: "List views",
	campaigns: "Campaigns",
	replies: "Replies",
	noReply: "No Reply",
	toBeNurtured: "To Be Nurtured",
	doNotContact: "Do Not Contact",
	messageCenter: "Message Center",
	outbox: "Outbox",
	readyToSend: "Review Leads",
	followUp: "Follow Up",
	explanationTexts: {
		listBuilder: "Build lead lists based on signals and lead databases with simple workflows",
		campaigns:
			"See every campaign across all lead lists in one place — status, reach and replies at a glance",
		profileTracker:
			"Track custom signals of your target accounts, clients and leads and even competitors",
		feed: "Review the latest signal runs of your tracked companies and reach out from one place",
		compose:
			"Write messages and sequences to any lead from any list or add and enrich any lead directly from Linkedin",
		inbox:
			" Unified Inbox for all unanswered emails and Linkedin messages. Use our Reply Agent to schedule up to two follow up messages",
		readyToSend:
			"Review all leads from all lists and adjust messages or completely re-write sequences for individual leads",
		followUp:
			"Reach out to leads who have been in previous campaigns, are existing Linkedin connections or have accepted your Linkedin connection request without replying",
		outbox:
			"See all sent and scheduled messages and replies and pause scheduled messages and sequences at any time",
		leadScoring:
			"Define your company & persona categories and lead scoring criteria that will be applied to any lead list",
		analytics: "Review campaign analytics to see which lists and campaigns perform better",
		accountSettings: "Invite and manage users, billing, and API & webhooks settings",
		copywriting:
			"Configure account-level copywriting defaults and frameworks used by the AI copywriting agent across all campaigns",
		templates: "Create and manage message templates for AI Snippets, AI Columns and Reply Texts",
		signals:
			"Configure signal definitions and priorities for tracking LinkedIn profile activities and buying intent",
		knowledgeDb:
			"View and manage AI-generated knowledge content organized by Company × Persona categories",
		contacts: "Manage all your contacts across every list in one place",
		contactsCompanies: "Manage the companies behind your contacts and leads",
		competitors:
			"Companies flagged as competitors — excluded from every list and search across your account",
		blacklist: "People and organizations that will never be contacted",
		integrations: "Connect HubSpot, Zoho, Pipedrive and other tools to sync your outreach activity",
	},
	adminFixes: "Admin Fixes",
	apiHealth: "API Health",
	support: "Support",
	featureUsage: "Feature usage",
	supportDashboard: "Support Dashboard",
};
